import {
  DecorativeElement,
  COMPONENTS,
  DOT_COLORS,
  DOT_CLASSES,
} from "../../../componentsGLob/Decorative/decorative-element.config";

export const TECH_DECORATIVES: DecorativeElement[] = [
  {
    id: "tech-digital-arrow-1",
    type: "arrow",
    Component: COMPONENTS.ArrowIcon,
    position: "top-[20%] left-[10%] md:left-[7%]",
    animation: {
      animate: { y: [0, 16, 0] },
      transition: {
        duration: 1.8,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className:
      "w-16 h-16 md:w-20 md:h-20 opacity-90 rotate-[45deg] hidden xl:block",
  },
  {
    id: "tech-digital-dot-red-1",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "top-[8%] left-[9%]",
    animation: {
      animate: {
        x: [0, 8, -6, 4, 0],
        y: [0, -10, 5, -6, 0],
        rotate: [0, 5, -5, 3, 0],
      },
      transition: {
        duration: 10,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className: `${DOT_COLORS.red} ${DOT_CLASSES.small}`,
  },
  {
    id: "tech-digital-dot-red-2",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "bottom-[12%] left-[5%]",
    animation: {
      animate: {
        x: [0, -8, 6, -4, 0],
        y: [0, 10, -5, 6, 0],
        rotate: [0, -5, 5, -3, 0],
      },
      transition: {
        duration: 14,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className: `${DOT_COLORS.red} ${DOT_CLASSES.medium}`,
  },
  {
    id: "tech-digital-dot-yellow-1",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "top-[18%] right-[8%]",
    animation: {
      animate: {
        x: [0, 10, -10, 5, 0],
        y: [0, -10, 10, -5, 0],
        rotate: [0, 4, -4, 2, 0],
      },
      transition: {
        duration: 12,
        repeat: Infinity,
      },
    },
    className: `${DOT_COLORS.yellow} ${DOT_CLASSES.small}`,
  },
  {
    id: "tech-digital-dot-yellow-2",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "bottom-[14%] right-[7%]",
    animation: {
      animate: {
        x: [0, -12, 8, -6, 0],
        y: [0, 12, -8, 6, 0],
        rotate: [0, -6, 6, -3, 0],
      },
      transition: {
        duration: 16,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className: `${DOT_COLORS.yellow} ${DOT_CLASSES.medium}`,
  },
  {
    id: "tech-digital-dot-cyan-1",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "top-[6%] right-[8%]",
    animation: {
      animate: {
        x: [0, 15, -15, 10, -10, 0],
        y: [0, -15, 15, -10, 10, 0],
        rotate: [0, 10, -10, 5, -5, 0],
      },
      transition: {
        duration: 22,
        repeat: Infinity,
      },
    },
    className: `${DOT_COLORS.cyan} ${DOT_CLASSES.medium}`,
  },
  {
    id: "tech-digital-dot-cyan-2",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "bottom-[10%] right-[4%]",
    animation: {
      animate: {
        x: [0, -10, 12, -8, 0],
        y: [0, 10, -12, 8, 0],
        rotate: [0, -8, 8, -4, 0],
      },
      transition: {
        duration: 20,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className: `${DOT_COLORS.cyan} ${DOT_CLASSES.small}`,
  },
];
